import parse from "html-react-parser";
import dynamic from "next/dynamic";

const CarsSpecifications = dynamic(() => import('./Specifications/Cars'));
const MotorcyclesSpecifications = dynamic(() => import('./Specifications/Motorcycles'));
const MarineSpecifications = dynamic(() => import('./Specifications/Marine'));
const PowerSpecifications = dynamic(() => import('./Specifications/Power'));

const SpecificationsComponent = props => {
	const { block } = props;

	const getSpecsCategory = () => {
		switch (props.category) {
			case "cars":
				return (<CarsSpecifications models={block.data.children} />)
			case "motorcycles":
				return (<MotorcyclesSpecifications models={block.data.children} />)
			case "marine":
				return (<MarineSpecifications models={block.data.children} />)
			case "power":
				return (<PowerSpecifications models={block.data.children} specs={block.data} />)
			default:
				return null;
		}
	}

	return (
		<div className="customContainer">
			<div className="specificationSection" id={block.data.navTitle ? block.data.navTitle.toLowerCase().replace(/ /g, '_') : ''}>
				<div className="row">
					<div className="col s12">
						<h2 className="cbTitle">{block.data.title}</h2>
					</div>
					<div className="col s12 cbDescription">
						{block.data.description ? parse(block.data.description) : ''}
					</div>
				</div>
				{getSpecsCategory()}
			</div>
		</div>
	);
};

export default SpecificationsComponent;